import React from 'react';
import { Footer } from '../Footer';
import { MessageBodyWrapper } from '../style';
import { Content } from './style';
import { Body } from '@lendi-ui/typography';
export var SentMessage = function (_a) {
    var message = _a.message, nextMessage = _a.nextMessage, members = _a.members, shouldShowTimestamp = _a.shouldShowTimestamp, shouldShowAvatars = _a.shouldShowAvatars, shouldShowSeenBy = _a.shouldShowSeenBy;
    return (React.createElement(React.Fragment, null,
        React.createElement(Content, null,
            React.createElement(MessageBodyWrapper, null, message.text)),
        (shouldShowTimestamp || shouldShowAvatars) && (React.createElement(Footer, { message: message, nextMessage: nextMessage, members: members, shouldShowAvatars: shouldShowAvatars })),
        shouldShowSeenBy && (React.createElement(Body, { size: "xxs", color: "shade.700", mt: "xxxs" },
            React.createElement("strong", null, "Seen by"),
            " ",
            message.seenByNames))));
};
//# sourceMappingURL=index.js.map